import AppConstants from 'constants/AppConstants';

import { consumer, toJSON } from '@tock/coretypes';

interface State {
  ticketTypes: consumer.ITicketType[];
  timeZone: string;
  businessDomain: string;
  businessName: string;
  isInitialized: boolean;
  locale: string;
  token: string;
}

const initialState: State = {
  ticketTypes: [],
  timeZone: 'America/Chicago',
  businessDomain: '',
  businessName: '',
  isInitialized: false,
  locale: 'en-US',
  token: '',
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.WIDGET_BUILDER_FETCH_TICKET_TYPES_DONE: {
      const response = toJSON(payload) as consumer.WidgetBuilder;
      return {
        ...state,
        ticketTypes: response.ticketType,
        timeZone: response.timeZone,
        businessDomain: response.businessDomain,
        businessName: response.businessName,
        isInitialized: true,
        locale: response.locale,
      };
    }
    case AppConstants.WIDGET_BUILDER_FETCH_TICKET_TYPES_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.WIDGET_BUILDER_FETCH_TICKET_TYPES_FAILED: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.WIDGET_BUILDER_TOKEN: {
      return {
        ...state,
        token: payload,
      };
    }

    default:
      return state;
  }
}
